import { Editor } from 'slate';
import { getListItemsInRange, pickSubtreesRoots } from "../lib/index.js";
import { decreaseListItemDepth } from "./decreaseListItemDepth.js";
/**
 * Decreases nesting depth of all "list-items" in the current selection.
 * All "list-items" in the root "list" will become "default" nodes.
 */

export function decreaseDepth(editor) {
  var at = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : editor.selection;

  if (!at) {
    return;
  }

  var listItems = getListItemsInRange(editor, at); // When calling `decreaseListItemDepth` the paths and references to "list-items"
  // can change, so we need a way of marking the "list-items" scheduled for transformation.

  var refs = pickSubtreesRoots(listItems).map(_ref => {
    var [_, path] = _ref;
    return Editor.pathRef(editor, path);
  });
  refs.forEach(ref => {
    if (ref.current) {
      decreaseListItemDepth(editor, ref.current);
    }

    ref.unref();
  });
}